import { useCallback, useEffect } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { includes } from 'ramda';
import { isNilOrEmpty, isObject } from 'ramda-extension';
import { useDispatch, useSelector } from 'react-redux';

import useControlNext from '@gef-ui/form-core/hooks/state/useControlNext';
import useFormData from '@gef-ui/form-core/hooks/state/useFormData';
import { resetForm } from '@gef-ui/form-core/stream/transfer/control';
import { getLabelMessage } from '@gef-ui/localization/messages';

import Agency from 'components/atoms/GefMui/OrganizationStructure/Agency';
import Region from 'components/atoms/GefMui/OrganizationStructure/Region';
import { AUTO_FILL_RULES, USER_ROLES } from 'constants/general';
import campaignDetail from 'features/views/campaignManagement/campaignDetail';
import { initializeOrganizationStructure, submitFilter } from 'features/views/campaignRegionNomination/actions';
import { CAMPAIGN_REGION_NOMINATIONS_FORM_NAME, FIELDS } from 'features/views/campaignRegionNomination/form';
import user from 'features/views/user';

export const Form = () => {
	const dispatch = useDispatch();
	const campaign = useSelector(campaignDetail.selectors.getCampaignDetail);
	const currentRole = useSelector(user.selectors.getCurrentRole);
	const next = useControlNext(CAMPAIGN_REGION_NOMINATIONS_FORM_NAME);
	const formData = useFormData();
	const formIsInitiated = isObject(formData);

	useEffect(() => {
		if (formIsInitiated && isNilOrEmpty(formData?.channel)) {
			dispatch(initializeOrganizationStructure());
		}
	}, [dispatch, formIsInitiated, formData?.channel]);

	const handleSubmitFilter = useCallback(() => {
		dispatch(submitFilter(formData));
	}, [dispatch, formData]);

	const handleReset = useCallback(() => {
		next(resetForm());
	}, [next]);

	return (
		<Grid container>
			<Grid size={12}>
				<Grid container spacing={2}>
					<Grid size={4}>
						<Region
							fieldName={FIELDS.region}
							formName={CAMPAIGN_REGION_NOMINATIONS_FORM_NAME}
							disableOnOneOptions={!includes(currentRole, AUTO_FILL_RULES.CENTRAL)}
							autoSelect
							campaignId={currentRole === USER_ROLES.GUARANTOR && campaign ? campaign.id : null}
						/>
					</Grid>
					<Grid size={4}>
						<Agency
							fieldName={FIELDS.agency}
							formName={CAMPAIGN_REGION_NOMINATIONS_FORM_NAME}
							disableOnOneOptions={!includes(currentRole, AUTO_FILL_RULES.REGION_MANAGER)}
							autoSelect
						/>
					</Grid>
					<Grid size={8} />
					<Grid size={2}>
						<Button variant="outlined" onClick={handleReset} fullWidth>
							{getLabelMessage('common:resetButton')}
						</Button>
					</Grid>
					<Grid size={2}>
						<Button variant="contained" onClick={handleSubmitFilter} fullWidth>
							{getLabelMessage('common:searchButton')}
						</Button>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default Form;
